import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconMontrealMinimapMarkers = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={376}
      height={375}
      fill="none"
      viewBox="0 0 376 375"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#icon-montreal-minimap-markers_svg__a)">
        <path
          fill="url(#icon-montreal-minimap-markers_svg__b)"
          fillOpacity={0.2}
          d="M268.18 298.072c-17.031-13.495-24.964-19.541-29.563-24.899l-50.211-54.525-22.259-24.44-16.97-18.633c-2.553-2.858-1.596-4.518-.657-5.989 1.501-2.353.563-4.412-1.22-6.408a441.84 441.84 0 0 1-2.011-2.183c-2.326-2.539-5.66-6.207-9.852-10.787a2596.913 2596.913 0 0 0-27.367-29.473C83.48 94.68 82.073 91.844 76.911 81.233l-.117-.241c-.809-1.663-1.47-3.02-2.069-4.284a135.343 135.343 0 0 1-2.976-6.716c-.856-1.933-1.715-3.91-2.534-5.673-1.115-2.403-2.154-4.407-3.003-5.358-1.532-1.716-4.69-.813-7.79-.105-1.297.296-2.771.581-4.223.525-2.722-.105-3.848-2.626-4.317-5.043-.47-3.467.938-5.253 2.159-6.618 2.721-3.047 9.197-5.463 20.271-8.615 3.007-.856 6.543-1.226 10.418-1.156 2.463.045 5.02.205 7.56.437 5.038.46 10.002 1.205 13.999 1.9 4.358.756 7.567 1.453 8.473 1.655 2.816.63 4.411 1.366 5.35 7.04.751 4.538 3.003 6.443 4.223 6.828 4.474 1.576 13.732 4.693 17.55 5.988 2.28.774 4.693 1.891 7.884 2.102 4.505 0 6.851-.106 9.385.42 4.138.479 8.765 3.69 12.684 8.389a40.17 40.17 0 0 1 3.458 4.848c2.151 3.847 4.916 8.866 7.65 13.652 1.92 3.36 3.825 6.607 5.49 9.251 1.879 2.984 3.519 4.262 4.973 4.518 4.036.524 5.419-3.601 7.79-5.99 1.976-1.99 5.256-3.151 11.075-1.05 4.411 1.996 8.81 6.703 14.922 15.233 1.443 1.985 2.901 3.987 4.377 6.038 5.005 6.956 10.213 14.479 15.707 23.799 3.368 6.283 6.642 12.111 10.136 19.33 2.056 4.247 4.714 9.84 6.101 13.973 2.638 7.862 4.7 14.281 6.288 19.405 2.761 8.913 4.086 13.913 4.505 15.789.938 4.203-2.253 4.203-4.505 6.724-.943 1.055-1.721 2.515-2.136 4.48-.575 2.73-.449 6.435.916 11.384a250.24 250.24 0 0 0 2.106 7.616c3.088 10.511 6.229 18.589 9.719 28.313 5.272 14.69 12.517 28.438 16.236 34.144 2.039 3.127 3.865 5.574 5.643 7.745 2.643 3.226 5.18 5.841 8.153 9.169 3.285 3.677 6.57 6.934 8.447 9.035 2.346 2.627 5.162 4.938 2.44 8.195-1.728 1.837-4.129 1.05-5.472-.598a71.87 71.87 0 0 1-2.568-3.087c-1.524-1.918-3.185-4.117-4.683-6.099l-.228-.302c-4.13-5.463-6.252-7.29-8.541-8.72-1.431-.894-5.003-3.155-10.548-7.067-4.88-3.444-11.288-8.168-19.109-14.364Z"
        />
        <path
          stroke="#fff"
          strokeOpacity={0.1}
          strokeWidth={10}
          d="M54.199 59.381c-2.722-.105-3.848-2.626-4.317-5.043-.47-3.467.938-5.253 2.159-6.618 2.721-3.047 9.197-5.463 20.271-8.615 3.007-.856 6.543-1.226 10.418-1.156 2.463.045 5.02.205 7.56.437 5.038.46 10.002 1.205 13.999 1.9 4.358.756 7.567 1.453 8.473 1.655 2.816.63 4.411 1.366 5.35 7.04.751 4.538 3.003 6.443 4.223 6.828 4.474 1.576 13.732 4.693 17.55 5.988 2.28.774 4.693 1.891 7.884 2.102 4.505 0 6.851-.106 9.385.42 4.138.479 8.765 3.69 12.684 8.389a40.17 40.17 0 0 1 3.458 4.848c2.151 3.847 4.916 8.866 7.65 13.652 1.92 3.36 3.825 6.607 5.49 9.251 1.879 2.984 3.519 4.262 4.973 4.518 4.036.524 5.419-3.601 7.79-5.99 1.976-1.99 5.256-3.151 11.075-1.05 4.411 1.996 8.81 6.703 14.922 15.233 1.443 1.985 2.901 3.987 4.377 6.038 5.005 6.956 10.213 14.479 15.707 23.799 3.368 6.283 6.642 12.111 10.136 19.33 2.056 4.247 4.714 9.84 6.101 13.973 2.638 7.862 4.7 14.281 6.288 19.405 2.761 8.913 4.086 13.913 4.505 15.789.938 4.203-2.253 4.203-4.505 6.724-.943 1.055-1.721 2.515-2.136 4.48-.575 2.73-.449 6.435.916 11.384a250.24 250.24 0 0 0 2.106 7.616c3.088 10.511 6.229 18.589 9.719 28.313 5.272 14.69 12.517 28.438 16.236 34.144 2.039 3.127 3.865 5.574 5.643 7.745 2.643 3.226 5.18 5.841 8.153 9.169 3.285 3.677 6.57 6.934 8.447 9.035 2.346 2.627 5.162 4.938 2.44 8.195-1.728 1.837-4.129 1.05-5.472-.598a71.87 71.87 0 0 1-2.568-3.087c-1.601-2.017-3.356-4.343-4.911-6.401-4.13-5.463-6.252-7.29-8.541-8.72-1.431-.894-5.003-3.155-10.548-7.067-4.88-3.444-11.288-8.168-19.109-14.364-17.031-13.495-24.964-19.541-29.563-24.899l-50.211-54.525-22.259-24.44-16.97-18.633c-2.553-2.858-1.596-4.518-.657-5.989 1.501-2.353.563-4.412-1.22-6.408a441.84 441.84 0 0 1-2.011-2.183c-2.326-2.539-5.66-6.207-9.852-10.787a2596.913 2596.913 0 0 0-27.367-29.473C83.48 94.68 82.073 91.844 76.911 81.233c-.863-1.773-1.558-3.2-2.186-4.525a135.343 135.343 0 0 1-2.976-6.716c-.856-1.933-1.715-3.91-2.534-5.673-1.115-2.403-2.154-4.407-3.003-5.358-1.532-1.716-4.69-.813-7.79-.105m-4.223.525c1.452.056 2.926-.229 4.223-.525m-4.223.525 4.223-.525"
        />
        <path
          fill="#CCC"
          d="M136.755 148.699c-.745-.814-1.938-.798-2.665.036-.727.833-.712 2.169.032 2.982l2.633-3.018Zm-2.633 3.018c4.178 4.565 7.535 8.258 9.853 10.788l2.631-3.02c-2.333-2.547-5.645-6.191-9.851-10.786l-2.633 3.018Z"
        />
        <path
          fill="#00FF2B"
          d="m147.299 163.178 1.332-1.492-.013-.014-.013-.015-1.306 1.521Zm1.22 6.408 1.533 1.226-1.533-1.226Zm-1.915-10.101c-.745-.814-1.938-.797-2.665.037-.726.834-.711 2.17.034 2.983l2.631-3.02Zm-.638 5.184c.819.916 1.225 1.62 1.363 2.158.098.386.105.831-.343 1.533l3.066 2.452c1.054-1.65 1.342-3.411.901-5.143-.403-1.578-1.357-2.902-2.322-3.983l-2.665 2.983Zm1.02 3.691c-.437.685-1.265 1.945-1.33 3.608-.07 1.784.719 3.455 2.187 5.098l2.665-2.983c-1.085-1.214-1.092-1.802-1.087-1.93.009-.249.13-.555.631-1.341l-3.066-2.452Zm-3.013-5.855c.789.861 1.465 1.596 2.02 2.193l2.612-3.041a408.864 408.864 0 0 1-2.001-2.172l-2.631 3.02Z"
        />
        <path
          fill="#FFC107"
          d="M150.496 174.069c-.743-.816-1.936-.803-2.664.029-.729.831-.718 2.167.025 2.983l2.639-3.012Zm-2.639 3.012 16.971 18.633 2.639-3.012-16.971-18.633-2.639 3.012Z"
        />
        <path
          fill="#CCC"
          d="m238.619 273.173 1.359-1.461-.023-.027-.024-.026-1.312 1.514Zm29.563 24.899-1.088 1.721 1.088-1.721Zm-79.773-79.424-1.32 1.506.008.008 1.312-1.514Zm-20.94-25.946c-.743-.816-1.936-.803-2.665.029-.729.832-.717 2.167.026 2.983l2.639-3.012Zm69.791 81.933c4.761 5.546 12.922 11.758 29.834 25.158l2.177-3.443c-17.15-13.59-24.856-19.469-29.293-24.638l-2.718 2.923Zm-50.163-54.473 50.21 54.525 2.624-3.028-50.21-54.525-2.624 3.028Zm79.997 79.631c7.848 6.219 14.284 10.963 19.192 14.427l2.01-3.569c-4.852-3.424-11.232-8.126-19.025-14.301l-2.177 3.443ZM164.83 195.714l22.259 24.44 2.639-3.012-22.259-24.44-2.639 3.012Z"
        />
        <path
          fill="#CCC"
          d="m297.838 319.504.919-1.842-.919 1.842Zm8.541 8.719 1.438-1.362-1.438 1.362Zm-18.084-17.572c-.88-.621-2.044-.326-2.599.66-.555.985-.291 2.288.589 2.909l2.01-3.569Zm8.625 10.694c2.021 1.263 3.974 2.888 8.02 8.241l2.877-2.725c-4.213-5.573-6.504-7.602-9.06-9.199l-1.837 3.683Zm8.02 8.241c1.551 2.051 3.322 4.4 4.942 6.44l2.816-2.804c-1.583-1.992-3.32-4.296-4.881-6.361l-2.877 2.725Zm-18.655-15.366c5.578 3.937 9.181 6.217 10.635 7.125l1.837-3.683c-1.408-.88-4.951-3.122-10.462-7.011l-2.01 3.569Z"
        />
        <path
          fill="#00FF2B"
          d="m319.331 338.309 1.298 1.529.04-.043.038-.045-1.376-1.441Zm-5.473-.598 1.393-1.421-.03-.036-.03-.034-1.333 1.491Zm-1.159-4.488c-.691-.871-1.882-.949-2.66-.175-.778.774-.848 2.107-.156 2.978l2.816-2.803Zm8.008 6.527c.864-1.034 1.443-2.18 1.59-3.458.148-1.287-.178-2.42-.642-3.347-.449-.899-1.073-1.693-1.657-2.368-.535-.619-1.29-1.412-1.775-1.954l-2.665 2.983c.689.771 1.166 1.251 1.733 1.907.519.598.869 1.079 1.076 1.493.193.386.208.606.192.749-.018.154-.107.518-.604 1.113l2.752 2.882Zm-8.241-.617c.928 1.138 2.24 2.012 3.692 2.268 1.507.265 3.144-.151 4.471-1.563l-2.596-3.058c-.4.426-.829.534-1.29.453-.516-.09-1.077-.434-1.492-.943l-2.785 2.843Zm-2.583-3.107a75.264 75.264 0 0 0 2.643 3.177l2.665-2.983a70.526 70.526 0 0 1-2.492-2.997l-2.816 2.803Z"
        />
        <path
          fill="#FF5252"
          d="m294.651 304.165-1.522 1.243 1.522-1.243Zm-16.237-34.144 1.749-.786-1.749.786Zm-7.928-28.972c-.325-1.107-1.39-1.709-2.379-1.345-.988.364-1.526 1.556-1.201 2.663l3.58-1.318Zm25.687 61.873c-3.621-5.555-10.793-19.148-16.01-33.687l-3.497 1.573c5.326 14.841 12.645 28.744 16.463 34.6l3.044-2.486Zm5.509 7.562c-1.732-2.114-3.513-4.5-5.509-7.562l-3.044 2.486c2.081 3.193 3.951 5.701 5.776 7.928l2.777-2.852Zm-21.519-41.249c-3.51-9.781-6.614-17.759-9.677-28.186l-3.58 1.318c3.112 10.596 6.291 18.774 9.76 28.441l3.497-1.573Z"
        />
        <path
          fill="#CCC"
          d="m266.587 234.092 1.809-.59-.004-.016-.004-.016-1.801.622Zm.919-10.899c.239-1.134-.388-2.27-1.401-2.538-1.013-.268-2.028.435-2.267 1.568l3.668.97Zm.882 10.277c-1.302-4.72-1.357-8.026-.882-10.277l-3.668-.97c-.677 3.209-.479 7.314.949 12.491l3.601-1.244Zm2.096 7.579a251.455 251.455 0 0 1-2.088-7.547l-3.618 1.179a253.99 253.99 0 0 0 2.126 7.686l3.58-1.318Z"
        />
        <path
          fill="#00FF2B"
          d="M263.836 222.223c-.239 1.134.388 2.27 1.401 2.538 1.012.268 2.027-.434 2.266-1.568l-3.667-.97Zm5.301-2.503c.41-.459.887-.831 1.452-1.226.499-.349 1.24-.824 1.824-1.335.638-.557 1.312-1.33 1.679-2.472.365-1.139.34-2.376.046-3.694l-3.656 1.023c.174.783.102 1.122.063 1.244-.038.119-.127.291-.45.574-.378.33-.799.59-1.502 1.082-.638.445-1.404 1.019-2.121 1.821l2.665 2.983Zm-1.634 3.473c.338-1.603.951-2.708 1.634-3.473l-2.665-2.983c-1.201 1.345-2.145 3.159-2.636 5.486l3.667.97Z"
        />
        <path
          fill="#FFC107"
          d="M269.585 195.024c-.341-1.1-1.414-1.683-2.397-1.302-.984.382-1.504 1.584-1.163 2.684l3.56-1.382Zm4.553 15.969c-.44-1.971-1.788-7.043-4.553-15.969l-3.56 1.382c2.757 8.9 4.059 13.828 4.457 15.61l3.656-1.023Z"
        />
        <path
          fill="#FF5252"
          d="m261.518 176.31 1.764-.742-1.764.742Zm-16.237-33.303 1.616-1.085-.021-.039-.022-.038-1.573 1.162Zm10.136 19.33-1.656 1.005 1.656-1.005Zm-24.375-44.452c-.653-.907-1.84-1.051-2.65-.32-.81.731-.938 2.059-.286 2.966l2.936-2.646Zm32.24 57.683c-1.441-4.294-4.167-10.018-6.208-14.235l-3.313 2.009c2.07 4.277 4.66 9.738 5.993 13.71l3.528-1.484Zm-6.208-14.235c-3.52-7.273-6.831-13.169-10.177-19.411l-3.231 2.17c3.39 6.325 6.627 12.085 10.095 19.25l3.313-2.009Zm12.512 33.691c-1.593-5.143-3.661-11.579-6.304-19.456l-3.528 1.484c2.633 7.847 4.69 14.249 6.271 19.354l3.561-1.382Zm-22.732-53.179c-5.541-9.399-10.79-16.98-15.812-23.96l-2.936 2.646c4.988 6.932 10.155 14.397 15.603 23.638l3.145-2.324Z"
        />
        <path
          fill="#CCC"
          d="m225.197 113.171-1.47 1.319.004.006.005.006 1.461-1.331ZM197.94 97.42c-.774.78-.837 2.113-.14 2.979.696.866 1.887.936 2.661.157l-2.521-3.136Zm12.335.517.706-1.955-.063-.029-.065-.023-.578 2.007Zm16.392 13.914c-6.109-8.526-10.774-13.647-15.686-15.87l-1.413 3.912c3.91 1.769 8.043 6.062 14.159 14.597l2.94-2.639ZM210.853 95.93c-6.242-2.254-10.29-1.153-12.913 1.49l2.521 3.136c1.328-1.338 3.84-2.56 9.235-.611l1.157-4.015Zm20.188 21.955c-1.479-2.057-2.941-4.064-4.383-6.046l-2.922 2.663c1.444 1.986 2.898 3.983 4.37 6.029l2.935-2.646Z"
        />
        <path
          fill="#00FF2B"
          d="M187.977 99.243c-.6-.952-1.775-1.18-2.626-.508-.851.67-1.054 1.987-.455 2.939l3.081-2.43Zm3.433 5.734-.293 2.084.037.007.039.005.217-2.096Zm6.53-7.557c-.71.715-1.322 1.535-1.843 2.243-.552.749-1.002 1.372-1.49 1.909-.893.985-1.712 1.475-2.98 1.31l-.434 4.191c2.768.359 4.658-.951 6.059-2.495.659-.727 1.251-1.551 1.752-2.231.531-.721.981-1.312 1.457-1.791l-2.521-3.136Zm-6.237 5.474c-.697-.123-1.95-.829-3.726-3.65l-3.081 2.43c1.983 3.148 4.011 4.997 6.221 5.387l.586-4.167Z"
        />
        <path
          fill="#FFC107"
          d="M182.534 90.072c-.56-.982-1.726-1.269-2.602-.64-.877.627-1.133 1.931-.573 2.912l3.175-2.272Zm5.442 9.171c-1.64-2.605-3.527-5.82-5.442-9.171l-3.175 2.272c1.926 3.37 3.848 6.648 5.537 9.33l3.08-2.43Z"
        />
        <path
          fill="#FF5252"
          d="m173.298 77.556 1.597-1.119-.019-.035-.021-.034-1.557 1.188Zm-2.082-6.288c-.71-.851-1.902-.897-2.663-.102-.76.795-.801 2.13-.091 2.981l2.754-2.879Zm3.639 5.1a42.35 42.35 0 0 0-3.639-5.1l-2.754 2.88a38.226 38.226 0 0 1 3.278 4.596l3.115-2.376Zm7.68 13.704c-2.728-4.775-5.481-9.772-7.64-13.635l-3.195 2.238c2.141 3.83 4.919 8.872 7.66 13.67l3.175-2.273Z"
        />
        <path
          fill="#FF5252"
          d="m157.156 64.319-.343 2.074.074.015.075.01.194-2.099Zm-17.269-2.521-.546 2.018.546-2.018Zm-16.984-8c-.993-.35-2.051.267-2.364 1.378-.312 1.111.24 2.296 1.232 2.645l1.132-4.024Zm24.868 10.1-.111 2.106.055.004h.056v-2.11Zm-7.337-4.12c-3.83-1.298-13.071-4.41-17.531-5.98l-1.132 4.023c4.487 1.58 13.762 4.704 17.57 5.995l1.093-4.037Zm17.065 2.467c-2.753-.57-5.341-.456-9.728-.456v4.22c4.622 0 6.727-.096 9.042.384l.686-4.148Zm-9.618-.452c-2.899-.19-4.984-1.178-7.447-2.014l-1.093 4.037c2.095.711 4.837 1.96 8.319 2.188l.221-4.21Zm23.336 9.476c-4.072-4.882-9.09-8.495-13.867-9.048l-.388 4.196c3.499.405 7.734 3.216 11.501 7.73l2.754-2.879Z"
        />
        <path
          fill="#00FF2B"
          d="m118.113 48.98-1.853.385 1.853-.385Zm-4.98-9.107c-1.021-.228-2.013.513-2.217 1.655-.204 1.142.457 2.254 1.478 2.482l.739-4.137Zm9.715 13.906c-.402-.127-2.236-1.276-2.882-5.183l-3.706.769c.855 5.17 3.526 7.83 5.565 8.474l1.023-4.06Zm-2.882-5.183c-.489-2.957-1.211-5.084-2.492-6.517-1.306-1.463-2.928-1.89-4.341-2.206l-.739 4.137c1.402.314 1.986.57 2.416 1.052.455.51 1.001 1.587 1.45 4.303l3.706-.769Z"
        />
        <path
          fill="#FFC107"
          d="M104.579 38.2c-1.028-.178-1.991.61-2.151 1.762-.16 1.151.545 2.229 1.573 2.408l.578-4.17Zm8.554 1.673c-.927-.207-4.164-.91-8.554-1.672l-.578 4.169c4.325.75 7.507 1.442 8.393 1.64l.739-4.137Z"
        />
        <path
          fill="#FF5252"
          d="M90.443 36.284c-1.037-.095-1.946.77-2.031 1.93-.085 1.162.688 2.18 1.725 2.274l.306-4.204ZM104.58 38.2c-4.026-.7-9.037-1.452-14.136-1.917l-.306 4.204c4.98.455 9.895 1.192 13.864 1.882l.578-4.17Z"
        />
        <path
          fill="#CCC"
          d="m72.312 39.105.464 2.044-.464-2.044Zm-21.604 7.123c-.736.824-.736 2.16 0 2.983.736.824 1.929.824 2.665 0l-2.665-2.983Zm32.021-8.279.031-2.109-.03 2.11Zm-10.881-.888c-5.548 1.579-10.015 2.993-13.456 4.411-3.393 1.4-6.02 2.893-7.684 4.756l2.665 2.983c1.056-1.183 3.028-2.422 6.322-3.78 3.246-1.339 7.555-2.709 13.081-4.282l-.928-4.088Zm10.912-1.22c-3.99-.073-7.701.306-10.912 1.22l.928 4.088c2.802-.797 6.164-1.159 9.923-1.09l.061-4.219Zm7.682.443c-2.57-.235-5.17-.398-7.682-.444l-.061 4.218c2.413.044 4.929.201 7.436.43l.307-4.204Z"
        />
        <path
          fill="#00FF2B"
          d="M53.372 49.211c.736-.824.736-2.16 0-2.983-.736-.824-1.929-.824-2.664 0l2.664 2.983Zm-3.49 5.127-1.864.316.01.067.012.065 1.841-.448Zm4.317 5.043-.065 2.108.065-2.108Zm4.223-.525.377 2.066-.377-2.066Zm-7.714-12.628c-.633.708-1.49 1.71-2.083 3.108-.614 1.448-.895 3.189-.607 5.318l3.727-.632c-.181-1.337.007-2.223.284-2.876.299-.703.756-1.277 1.343-1.935l-2.664-2.983Zm-2.668 8.558c.265 1.363.748 2.957 1.688 4.264.995 1.382 2.453 2.364 4.406 2.44l.13-4.217c-.77-.03-1.235-.361-1.601-.87-.42-.584-.736-1.459-.94-2.513l-3.683.896Zm6.094 6.703c1.688.065 3.348-.266 4.665-.566l-.754-4.134c-1.278.292-2.567.53-3.782.484l-.13 4.216Zm4.665-.566c1.637-.375 3.025-.731 4.227-.819 1.243-.09 1.69.165 1.853.348l2.665-2.983c-1.369-1.532-3.268-1.683-4.762-1.575-1.534.112-3.275.561-4.737.895l.754 4.133Zm-4.392.554 4.223-.525-.416-4.193-4.224.526.417 4.193Zm10.472-1.025c.264.296.643.863 1.13 1.748.47.858.985 1.909 1.534 3.091l3.344-1.945a57.194 57.194 0 0 0-1.668-3.355c-.525-.956-1.09-1.866-1.675-2.522l-2.665 2.983Z"
        />
        <path
          fill="#FFC107"
          d="m71.751 69.992 1.71-.887-.01-.025-.011-.025-1.689.937Zm-.862-6.646c-.48-1.033-1.617-1.436-2.54-.899-.924.537-1.284 1.81-.804 2.844l3.344-1.945Zm-.847 7.533a137.589 137.589 0 0 0 3.02 6.818l3.33-1.978a133.079 133.079 0 0 1-2.93-6.614l-3.42 1.774Zm-2.497-5.588c.808 1.74 1.653 3.684 2.518 5.638l3.376-1.874c-.846-1.912-1.72-3.922-2.55-5.709l-3.344 1.945Z"
        />
        <path
          fill="#FF5252"
          d="m76.911 81.233-1.655 1.009 1.655-1.009Zm31.159 39.502-1.296 1.532 1.296-1.532ZM76.39 75.719c-.489-1.029-1.63-1.42-2.549-.874-.919.546-1.268 1.823-.78 2.852l3.328-1.978Zm-1.134 6.523c2.597 5.339 4.316 8.86 8.521 14.327 4.144 5.387 10.713 12.682 22.997 25.698l2.591-3.064c-12.305-13.039-18.734-20.19-22.732-25.387-3.937-5.118-5.502-8.32-8.067-13.592l-3.31 2.018Zm31.518 40.025a2607.448 2607.448 0 0 1 27.347 29.45l2.632-3.018a2596.449 2596.449 0 0 0-27.388-29.496l-2.591 3.064Zm-33.713-44.57c.634 1.337 1.334 2.775 2.195 4.545l3.31-2.018c-.865-1.776-1.554-3.192-2.177-4.505l-3.328 1.978Z"
        />
        <path
          fill="#FFC107"
          d="M301.679 310.484c-.704-.858-1.896-.916-2.663-.129-.767.788-.818 2.122-.115 2.981l2.778-2.852Zm16.543 18.139c-.967-1.083-2.29-2.456-3.74-3.975a211.59 211.59 0 0 1-4.706-5.06l-2.665 2.983a214.182 214.182 0 0 0 4.796 5.157c1.483 1.553 2.74 2.859 3.65 3.878l2.665-2.983Zm-8.446-9.035c-3.042-3.405-5.489-5.92-8.097-9.104l-2.778 2.852c2.677 3.267 5.305 5.983 8.21 9.235l2.665-2.983Z"
        />
        <g filter="url(#icon-montreal-minimap-markers_svg__c)">
          <rect width={20} height={20} x={71.5} y={50} fill="#26A69A" rx={10} />
          <g filter="url(#icon-montreal-minimap-markers_svg__d)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m81.327 57.076-1.836.948V56.74l2.076-1.14h1.152V64h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__e)">
          <rect width={20} height={20} x={28.5} y={53} fill="#26A69A" rx={10} />
          <g filter="url(#icon-montreal-minimap-markers_svg__f)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m35.505 65.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V67h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__g)">
          <rect
            width={20}
            height={20}
            x={120.5}
            y={31}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__h)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M127.287 43.764v-1.188h1.392v.768l.468.456h2.28l.468-.456V41.82l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L132.051 45h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__i)">
          <rect
            width={20}
            height={20}
            x={111.5}
            y={64}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__j)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M122.207 76.392h-4.08V74.82l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V78h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__k)">
          <rect
            width={20}
            height={20}
            x={175.5}
            y={62}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__l)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M182.389 74.764V73.54h1.392v.804l.468.456h2.256l.468-.456V72.28l-.468-.468h-3.996V67.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L187.129 76h-3.504l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__m)">
          <rect
            width={20}
            height={20}
            x={182.5}
            y={113}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__n)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M189.409 125.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L194.221 127h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__o)">
          <rect
            width={20}
            height={20}
            x={214.5}
            y={81}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__p)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M225.661 88.028V87.8h-4.248v-1.2h5.688v1.464L223.753 95h-1.464l3.372-6.972Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__q)">
          <rect
            width={20}
            height={20}
            x={277.5}
            y={202}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__r)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M284.256 214.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L289.26 216h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__s)">
          <rect
            width={20}
            height={20}
            x={241.5}
            y={222}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__t)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M248.44 234.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L253.132 236h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__u)">
          <rect
            width={20}
            height={20}
            x={328.5}
            y={329}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__v)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m334.341 336.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L342.559 343h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__w)">
          <rect
            width={20}
            height={20}
            x={282.5}
            y={330}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__x)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m289.958 337.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__y)">
          <rect
            width={20}
            height={20}
            x={241.5}
            y={296}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__z)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m247.803 303.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V310h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__A)">
          <rect
            width={20}
            height={20}
            x={129.5}
            y={178}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__B)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m135.634 185.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L143.42 192h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__C)">
          <rect
            width={20}
            height={20}
            x={152.5}
            y={149}
            fill="#26A69A"
            rx={10}
          />
          <g filter="url(#icon-montreal-minimap-markers_svg__D)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m158.774 156.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.802 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V163h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-montreal-minimap-markers_svg__E)">
          <path
            fill="#fff"
            fillOpacity={0.95}
            d="m84.24 91.938 2.544 2.848-2.858 3.2-2.545-2.848zM78.522 98.338l2.545 2.848-2.859 3.2-2.544-2.848zM72.805 104.739l2.544 2.848-2.859 3.2-2.544-2.848zM67.087 111.139l2.544 2.848-2.859 3.2-2.544-2.848zM61.37 117.539l2.543 2.848-2.858 3.2-2.545-2.848zM83.926 97.986l2.544 2.848-2.859 3.2-2.544-2.848zM78.208 104.386l2.544 2.848-2.858 3.2-2.545-2.848z"
          />
          <path
            fill="#fff"
            fillOpacity={0.95}
            d="m72.49 110.787 2.544 2.848-2.858 3.2-2.545-2.848zM66.772 117.187l2.545 2.848-2.859 3.2-2.544-2.848z"
          />
          <path
            fill="#000"
            d="m86.784 94.786 2.544 2.848-2.858 3.2-2.545-2.848zM81.067 101.186l2.545 2.848-2.86 3.2-2.543-2.848zM75.35 107.587l2.544 2.848-2.859 3.2-2.544-2.848zM69.632 113.987l2.544 2.848-2.859 3.2-2.544-2.848zM63.914 120.388l2.544 2.848-2.858 3.2-2.545-2.848z"
          />
          <path
            fill="#000"
            d="m81.382 95.138 2.544 2.848-2.859 3.2-2.544-2.848zM75.664 101.538l2.544 2.848-2.858 3.2-2.545-2.848zM69.946 107.939l2.545 2.848-2.86 3.2-2.543-2.848zM64.228 114.339l2.545 2.848-2.859 3.2-2.544-2.848z"
          />
          <path
            fill="#E2645A"
            d="m38.56 106.398 3.136 17.448 12.483-13.973-15.618-3.475Zm-1.429-1.601c.46-.515 1.078-.784 1.701-.636l16.353 3.68c1.277.262 1.607 2.005.595 3.138l-13.126 14.694c-.982 1.099-2.57.763-2.835-.632l-3.256-18.339a2.375 2.375 0 0 1 .568-1.905Z"
          />
        </g>
      </g>
      <defs>
        <filter
          id="icon-montreal-minimap-markers_svg__c"
          width={36}
          height={36}
          x={63.5}
          y={44}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__d"
          width={19.227}
          height={24.4}
          x={71.491}
          y={49.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__e"
          width={36}
          height={36}
          x={20.5}
          y={47}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__f"
          width={21.831}
          height={24.4}
          x={27.457}
          y={52.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__g"
          width={36}
          height={36}
          x={112.5}
          y={25}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__h"
          width={22}
          height={24.4}
          x={119.287}
          y={30.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__i"
          width={36}
          height={36}
          x={103.5}
          y={58}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__j"
          width={22.492}
          height={24.4}
          x={110.127}
          y={63.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__k"
          width={36}
          height={36}
          x={167.5}
          y={56}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__l"
          width={21.977}
          height={24.4}
          x={174.389}
          y={61.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__m"
          width={36}
          height={36}
          x={174.5}
          y={107}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__n"
          width={22.048}
          height={24.4}
          x={181.409}
          y={112.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__o"
          width={36}
          height={36}
          x={206.5}
          y={75}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__p"
          width={21.688}
          height={24.4}
          x={213.413}
          y={80.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__q"
          width={36}
          height={36}
          x={269.5}
          y={196}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__r"
          width={22.24}
          height={24.4}
          x={276.256}
          y={201.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__s"
          width={36}
          height={36}
          x={233.5}
          y={216}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__t"
          width={22.048}
          height={24.4}
          x={240.32}
          y={221.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__u"
          width={36}
          height={36}
          x={320.5}
          y={323}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__v"
          width={27.386}
          height={24.4}
          x={324.505}
          y={328.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__w"
          width={36}
          height={36}
          x={274.5}
          y={324}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__x"
          width={23.966}
          height={24.4}
          x={280.122}
          y={329.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__y"
          width={36}
          height={36}
          x={233.5}
          y={290}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__z"
          width={26.689}
          height={24.4}
          x={237.968}
          y={295.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__A"
          width={36}
          height={36}
          x={121.5}
          y={172}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__B"
          width={26.858}
          height={24.4}
          x={125.798}
          y={177.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__C"
          width={36}
          height={36}
          x={144.5}
          y={143}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__D"
          width={27.05}
          height={24.4}
          x={148.938}
          y={148.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <filter
          id="icon-montreal-minimap-markers_svg__E"
          width={76.064}
          height={83.237}
          x={21.265}
          y={66}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_49836"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_49836"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_49836"
            result="effect2_dropShadow_9632_49836"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_49836"
            result="shape"
          />
        </filter>
        <linearGradient
          id="icon-montreal-minimap-markers_svg__b"
          x1={176.499}
          x2={250.309}
          y1={206.16}
          y2={140.223}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4FC5BA" />
          <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
        </linearGradient>
        <clipPath id="icon-montreal-minimap-markers_svg__a">
          <path fill="#fff" d="M.5 0h375v375H.5z" />
        </clipPath>
      </defs>
    </svg>
  )
);
export default SvgIconMontrealMinimapMarkers;
